import type { FixtureConfigSlice, TournamentDraft } from '@/features/tournament-wizard/engine/types';
import {
  FixtureType,
  OverflowGroupClassification,
  TournamentFormat,
} from '@/types/tournament.model';

type GroupStageConfig = Pick<FixtureConfigSlice, 'format' | 'fixtureType'>;

/** Corto or Americano with a group stage: the formats where the group of 4 is configurable. */
export function hasConfigurableGroupStage(
  fixtureConfig: GroupStageConfig | null | undefined,
): boolean {
  return (
    (fixtureConfig?.format === TournamentFormat.SHORT ||
      fixtureConfig?.format === TournamentFormat.AMERICAN) &&
    fixtureConfig?.fixtureType === FixtureType.GROUPS_AND_KNOCKOUTS
  );
}

/**
 * Checkbox en Formato → tarjeta "Configuración de grupos": Corto o Americano + grupos + eliminatorias.
 */
export function showOverflowGroupClassificationField(
  draft: TournamentDraft,
): boolean {
  return hasConfigurableGroupStage(draft.fixtureConfig);
}

/**
 * API: Corto o Americano + grupos; si no aplica, STANDARD.
 */
export function resolveOverflowGroupClassificationForApi(
  fixtureConfig:
    | (GroupStageConfig & Pick<FixtureConfigSlice, 'overflowGroupClassification'>)
    | null,
): OverflowGroupClassification {
  if (fixtureConfig && hasConfigurableGroupStage(fixtureConfig)) {
    return fixtureConfig.overflowGroupClassification ?? OverflowGroupClassification.STANDARD;
  }
  return OverflowGroupClassification.STANDARD;
}
